(function (angular) {
    'use strict';

    angular.
        module('app.landing', ['ui.keypress']);

}(angular));